<ng-container *ngIf="vo$ | async; let vo">
	<div class="app-public-project-view__pic">
		<img *ngIf="vo.project" [src]="vo.project.pictoUrl" [alt]="vo.project.projectLabel"/>
	</div>
	<div *ngIf="vo.project" class="app-public-project-view__details">
		<div class="entry">
			<span class="entry-label" i18n="@@entity.list.publicProjectView.projectLabel">projectLabel</span>
			<span appHoverCopy>{{vo.project.projectLabel}}</span>
		</div>

		<div class="entry">
			<span class="entry-label" i18n="@@entity.list.publicProjectView.elemLabel">elemLabel</span>
			<span appHoverCopy>{{vo.project.elemLabel}}</span>
		</div>

		<div class="entry">
			<span class="entry-label" i18n="@@entity.list.publicProjectView.elemId">elemId</span>
			<span appHoverCopy>{{vo.project.elemId}}</span>

			<div class="public-project-view-horizontal-separator"></div>

			<span class="entry-label" i18n="@@entity.list.publicProjectView.elemCode">elemCode</span>
			<span appHoverCopy>{{vo.project.elemCode}}</span>
		</div>

		<div class="entry">
			<ng-container *ngIf="vo.project.depotCount !== 0">
				<span class="entry-label" i18n="@@entity.list.publicProjectView.activeDepotCount">activeDepotCount</span>
				<span>{{vo.project.depotCount}}</span>
			</ng-container>

			<div class="public-project-view-horizontal-separator"></div>

			<ng-container *ngIf="vo.project.characCount !== 0">
				<span class="entry-label" i18n="@@entity.list.publicProjectView.characteristicCount">characteristicCount</span>
				<span>{{vo.project.characCount}}</span>
			</ng-container>
		</div>

		<div class="entry">
			<span class="entry-label" i18n="@@entity.list.publicProjectView.createdOn">createdOn</span>
			<span>{{vo.project.createdOn | date: 'yyyy-MM-dd HH:mm' }}</span>
			<span class="entry-label" i18n="@@entity.list.publicProjectView.actionBy">actionBy</span>
			<app-avatar [avatar]="vo.project.createdBy"></app-avatar>
		</div>

		<div *ngIf="vo.project.updatedBy" class="public-project-view-vertical-separator"></div>

		<div *ngIf="vo.project.updatedBy" class="entry">
			<span class="entry-label" i18n="@@entity.list.publicProjectView.updatedOn">updatedOn</span>
			<span>{{vo.project.updatedOn | date: 'yyyy-MM-dd HH:mm' }}</span>
			<span class="entry-label" i18n="@@entity.list.publicProjectView.actionBy">actionBy</span>
			<app-avatar *ngIf="vo.project.updatedBy" [avatar]="vo.project.updatedBy"></app-avatar>
		</div>
	</div>
</ng-container>
